import React from 'react';
import PropTypes from 'prop-types';

const EmptyIcon = ({ name }) => (
  <>
    {name === 'pools' && (
      <svg width="60" height="57" viewBox="0 0 60 57" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="10.5833" y="1.37744" width="48" height="48" rx="9" fill="#27282D" stroke="#8D6752" strokeWidth="2" />
        <rect x="1.41669" y="7.31567" width="48" height="48" rx="9" fill="#27282D" stroke="#8D6752" strokeWidth="2" />
        <line
          x1="15.6901"
          y1="19.2981"
          x2="15.6901"
          y2="30.3157"
          stroke="#8D6752"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <line
          x1="21.1581"
          y1="24.7737"
          x2="10.1406"
          y2="24.7737"
          stroke="#8D6752"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <rect
          x="28.9006"
          y="18.1982"
          width="12.1177"
          height="12.1177"
          rx="2"
          fill="#27282D"
          stroke="#8D6752"
          strokeWidth="2"
        />
        <rect
          x="28.9006"
          y="35.7837"
          width="12.1177"
          height="12.1177"
          rx="2"
          fill="#27282D"
          stroke="#8D6752"
          strokeWidth="2"
        />
        <rect
          x="10.1408"
          y="35.7837"
          width="12.1177"
          height="12.1177"
          rx="2"
          fill="#27282D"
          stroke="#8D6752"
          strokeWidth="2"
        />
      </svg>
    )}
    {name === 'profile' && (
      <svg width={58} height={57} viewBox="0 0 58 57" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect
          x={1.146}
          y={1.482}
          width={55.708}
          height={53.938}
          rx={9}
          fill="#27282D"
          stroke="#8D6752"
          strokeWidth={2}
        />
        <rect
          x={1}
          y={-1}
          width={24.704}
          height={12.446}
          rx={2}
          transform="matrix(1 0 0 -1 15.648 21.835)"
          fill="#27282D"
          stroke="#8D6752"
          strokeWidth={2}
        />
        <path stroke="#8D6752" strokeWidth={2} d="M15.648 30.975h26.704M15.648 38.456h26.704M15.648 46.513h26.704" />
      </svg>
    )}
  </>
);

EmptyIcon.defaultProps = {
  name: 'pools',
};

EmptyIcon.propTypes = {
  name: PropTypes.oneOf(['profile', 'pools']),
};

export default EmptyIcon;
